"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidConnectFlow/steps/PlaidCategorySelectStep";

import React from "react";
import { Icon } from "@ospweb/sdk-ui";
import { PlaidSecurityBadge } from "../shared/PlaidSecurityBadge";
import { AccountCategoryCards } from "../shared/AccountCategoryCards";
import type { PlaidAccountCategory } from "../types";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidCategorySelectStepProps {
  onSelectCategory: (cat: PlaidAccountCategory) => void;
  onBack?: () => void;
  onClose?: () => void;
}

export const PlaidCategorySelectStep: React.FC<
  PlaidCategorySelectStepProps
> = ({ onSelectCategory, onBack, onClose }) => {
  return (
    <div className="flex-1 min-h-0 flex flex-col bg-background_solid_secondary text-content_primary">
      {/* Top Nav Header — fixed outside the scroll area */}
      <div className="flex items-center justify-between w-full shrink-0 min-h-[44px] px-4 pt-3 md:px-6 md:pt-4">
        {onBack ? (
          <button
            type="button"
            onClick={onBack}
            data-openreplay-label="plaidconnectflow_step_back"
            className="size-10 rounded-full bg-background_solid_primary shadow-[0px_2px_10px_rgba(0,0,0,0.08)] flex items-center justify-center text-content_primary hover:opacity-90 active:scale-95 transition-all cursor-pointer"
            aria-label={I18n.t("Go back")}
          >
            <Icon name="left-arrow-alt" size={20} />
          </button>
        ) : (
          <div className="size-10" />
        )}

        {onClose && (
          <button
            type="button"
            onClick={onClose}
            data-openreplay-label="plaidconnectflow_step_close"
            className="size-10 rounded-full bg-background_solid_primary shadow-[0px_2px_10px_rgba(0,0,0,0.08)] flex items-center justify-center text-content_primary hover:opacity-90 active:scale-95 transition-all cursor-pointer"
            aria-label={I18n.t("Close")}
          >
            <Icon name="close" size={20} />
          </button>
        )}
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto px-4 pb-3 md:px-6 md:pb-4">
        {/* Main Content */}
        <div className="flex flex-col max-w-[361px] mx-auto w-full pt-4 pb-8 gap-6">
          {/* Header Copy */}
          <div className="flex flex-col gap-2 w-full text-left">
            <h1 className="font-['Lexend'] text-2xl font-normal text-content_primary leading-8 tracking-[-0.96px]">
              {I18n.t("How would you like to connect?")}
            </h1>
            <p className="text-sm text-content_secondary leading-5">
              {I18n.t("Pick one to start. You can add the rest any time.")}
            </p>
          </div>

          {/* Cards */}
          <AccountCategoryCards onSelectCategory={onSelectCategory} />

          {/* Bottom Trust Security Note */}
          <div className="w-full">
            <PlaidSecurityBadge />
          </div>
        </div>
      </div>
    </div>
  );
};
